var prevTimestamp, listFrameTimes = [], listFrameRates = [];
var frameRecording = false, frameCount;
var fpsStart = 0, fpsMean = 0, fpsSD = 0;
var recordedFramerate = false;

function shouldBenchmarkFramerate(){
    if(recordedFramerate){
        return false;
    }
    if(window.record_framerate && window.record_framerate == "on"){
        return true;
    }
}

function showFramerateBenchmark(){
    const recordingTime = 10;
    displayText("title", "Recording frame rate for 10 more seconds.");
    displayText("content", "This should last 10 seconds");

    var remainingTime = recordingTime;

    var recordingTimer = setInterval(function(){
        remainingTime--;
        var recordingText = remainingTime + textScreens['refreshRate'][language]['remainingTime'];
        displayText("title", recordingText);
        displayText("content", textScreens['refreshRate'][language]['currentFramerate'] + window.listFrameRates[window.listFrameRates.length - 1].toFixed(2) || 0);
    }, 1000);

    window.setTimeout(function(){
        window.recordedFramerate = true;
        window.fpsStart = window.listFrameRates[window.listFrameRates.length - 1].toFixed(2);
        clearInterval(recordingTimer);
        displayText("title", textScreens['refreshRate'][language]['recordedFramerate']);
        displayText("content", textScreens['refreshRate'][language]['averageFramerate'] + window.fpsStart);

        window.setTimeout(function(){
            displayText("title", "");
            displayText("content", "");
            main();
        }, 3000);

    }, recordingTime * 1000);
}

function determineRefreshRate(){
    var duration = 2000;
    // const refreshRateList = [60, 75, 100, 120, 144, 165, 180, 200, 240];
    // const refreshIntervals = [
    //     [45, 14.67],
    //     [14.66, 11.68],
    //     [11.67, 9.14],
    //     [9.13, 7.62],
    //     [7.61, 6.5],
    //     [6.49, 5,81],
    //     [5.80, 5,28],
    //     [5,27, 4,59],
    //     [4.58, 0]
    // ];
    var timesBetweenFrames = [];
    var prevTimestamp = 0;
    var startTime = 0;
    var shouldStop = false;
    var hasIncreasedPercentage = false;
    window.requestAnimationFrame(getTimeBetweenFrames);
    setTimeout(function(){
        shouldStop = true;
    }, duration);

    function getTimeBetweenFrames(timestamp){
        if (prevTimestamp > 0) {
            timesBetweenFrames.push(timestamp - prevTimestamp);
        } else {
            startTime = timestamp;
        }
        prevTimestamp = timestamp;
        if(!shouldStop){
            window.requestAnimationFrame(getTimeBetweenFrames);
        }
        else{
            getRefreshRate(timesBetweenFrames);
        }

        if ( !hasIncreasedPercentage && (timestamp - startTime) > duration / 2) {
            QueryLoader.animatePercentage(99);
            hasIncreasedPercentage = true;
        }
    }

    function getRefreshRate(times){
        var count = 0, timesSum = 0;
        for(var i = 0; i < times.length; i++){
            //ignore times > 45 ms (24hz), treat them as inaccuracies
            if(times[i] < 45){
                timesSum += times[i];
                count++;
            }
        }

        // if all frames are > 45ms, then we default to 60 fps
        const avgFrameTimes = count ? timesSum/count : 1000/60;

        console.log('avg framerate', times, avgFrameTimes);
        window.frameRate = avgFrameTimes;
        QueryLoader.animatePercentage(100);
        setTimeout(function() {
            onPrepareDone('frameRate');
        }, 200);
        // for(var i = 0; i < refreshRateList.length; i++){
        //     if(avgFrameTimes < refreshIntervals[i][0] && avgFrameTimes > refreshIntervals[i][1]){
        //         console.log('chosen framerate', refreshRateList[i]);
        //         window.frameRate = refreshRateList[i];
        //         QueryLoader.animatePercentage(100, true, 200);
        //         setTimeout(function() {
        //             onPrepareDone('frameRate');
        //         }, 200);
        //     }
        // }
    }
}